import i18n from 'config/i18n';
import * as yup from 'yup';

import { PlanUnitMix } from 'components/types';

import { getLocale } from 'utils/date';
import { stringToFloat } from 'utils/misc';

const PlanUnit = yup.mixed<PlanUnitMix>();

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  return yup.object({
    name: yup
      .string()
      .required(t('validationFieldRequired', { name: t('scenario.name') })),
    costCenters: yup
      .array()
      .min(1, ({ min }) =>
        t('validationSelectAtLeast', {
          number: min,
          name: t('planUnit')
        })
      )
      .of(PlanUnit)
      .required(
        t('validationFieldRequired', { name: t('scenario.planUnits') })
      ),
    year: yup
      .number()
      .required(t('validationFieldRequired', { name: t('scenario.year') }))
      .transform(stringToFloat)
      .typeError(t('enterAValidValue')),
    scenarioId: yup.number().optional(),
    note: yup.string(),
    isDefault: yup.boolean().optional()
  });
};

export default getSchema;
